import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Container,
  Card,
  CardBody,
} from "reactstrap";
import { SuccessOk } from "configs/statusCode";
import SalesDeveloperService from "services/SalesDeveloper/SalesDeveloperService";
import EditProfile from "./EditProfileModal";
import { useDispatch } from "react-redux";
import { appendFilters } from "store/adminFilter/actions";

const ProfilePage = (props) => {
  const [editModal, setEditModal]= useState(false)
  const [developer, setDeveloper] = useState(null);
  const salesDeveloperService = new SalesDeveloperService()
  const dispatch = useDispatch()

  useEffect(()=>{
    dispatch(appendFilters({compound_id: null}))
  },[])

  useEffect(() => {
    salesDeveloperService.getProfile().then(res => {
      if (res && res.status === SuccessOk)
        setDeveloper({ ...res.data })
    })
  }, [editModal])

  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Sales Developer Profile</title>
        </MetaTags>
        <Container fluid>
          <h4>
            Sales Developer Profile
          </h4>
          <Card className="w-100 mt-4">
            <CardBody>
              <div className="d-flex mb-3" style={{justifyContent: "space-between"}}>
                <h5 className="m-0">Information</h5>
                <button className="border-0" style={{background: 'none'}} onClick={()=>setEditModal(true)}>
                  <i className="fa fa-edit font-size-18"></i>
                </button>
              </div>
              <h5 className="pt-2 border-bottom pb-3">
                <span className="font-size-14 text-muted">Name</span>
                <span className="font-size-14 ps-2">{developer ?.name ?.en}</span>
              </h5>
              <h5 className="pt-2 font-size-14">
                <span className="text-muted">Mobile Number</span>
                <span className=" ps-2">{developer ?.phone}</span>
              </h5>
              <h5 className="pt-2 font-size-14">
                <span className="text-muted">Email Address</span>
                <span className=" ps-2">{developer ?.email}</span>
              </h5>
            </CardBody>
          </Card>
        </Container>
        {editModal && <EditProfile modal={editModal} toggle={()=> setEditModal(false)} data={developer} />}
      </div>
    </React.Fragment>
  );
};

export default ProfilePage;
